import { appFormUtil } from 'modules/common';
import { StyledDropDown } from 'modules/components/layer01';
import React from 'react';
import * as ds from './dataService';



export type SelectRoleFieldProps<T extends object> = appFormUtil.SelectFieldProps<T> & {
  isMultiple?: boolean;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: SelectRoleFieldProps<T>) => {
  const { data } = ds.useQuery();

  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      options={data}
      multiple={props.isMultiple}
    />
  );
};
